import { createSelector } from '@reduxjs/toolkit';

import { OrgRoleType, TermsStatus } from '@/lib/api';
import type { RootState } from '@/state/store';

import type { AuthState } from './types';

export const getAuthState = (state: RootState): AuthState => state.auth;
export const isAuthenticated = createSelector(getAuthState, (state: AuthState) => state.authenticated);
export const isAuthenticating = createSelector(getAuthState, (state: AuthState) => state.loading);
export const getToken = createSelector(getAuthState, ({ token }: AuthState) => (token ? `Bearer ${token}` : ''));

// #region User
export const getCurrentUser = createSelector(getAuthState, (state: AuthState) => state.user);
export const isTermsAccepted = createSelector(
    getAuthState,
    (state: AuthState) => state.user?.terms_status === TermsStatus.accepted
);
export const isSuperuser = createSelector(getAuthState, (state: AuthState) => state.user?.admin ?? false);
// #endregion User

// #region role
export const getRole = createSelector(getAuthState, (state: AuthState): OrgRoleType | undefined => state.role);
export const isOrgAdmin = createSelector(getRole, (role?: OrgRoleType): boolean => role === OrgRoleType.admin);
// #endregion role
